module.exports = __webpack_public_path__ + "img/yw-4.f4a33637.svg";